import { tv } from "../../variants/tv.js";
const Select_variants_select = tv({
    slots: {
        root: 'relative isolate flex flex-col gap-1 antialiased',
        label: 'relative text-body3 text-primary-13 hover:cursor-pointer',
        inputWrapper: [
            'relative flex items-center justify-items-start gap-3 bg-primary-1 px-4 py-2 text-left',
            'rounded-xl border border-primary-6',
            'focus-visible:shadow-input-focus focus-visible:outline-primary-8',
            'hover:cursor-pointer hover:border-primary-10 hover:shadow-input-hover'
        ],
        input: 'w-full truncate text-body1 text-primary-13',
        helperText: 'ml-4 text-body3 text-primary-13',
        errorText: 'ml-4 text-body3 text-error-8',
        iconLeft: 'text-primary-8',
        iconRight: 'flex text-primary-10',
        popupPositioner: '',
        popupMenu: 'max-h-[var(--available-height)] min-w-[var(--anchor-width)] overflow-y-auto rounded-xl bg-primary-1 p-[4px] shadow-overlay-md outline-none',
        popupItem: [
            'flex min-h-[40px] w-full items-center justify-between gap-[12px] rounded-lg px-[12px] py-[8px]',
            'hover:cursor-pointer hover:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-8 [&:hover,&:focus]:bg-primary-2'
        ],
        itemLabel: 'text-body2',
        itemLabelHelper: 'text-body3',
        itemSuffix: 'text-body2 text-primary-10',
        itemIcon: 'mr-[12px] text-primary-10',
        itemLabelIconSuffixWrapper: 'flex w-full items-center justify-between gap-[8px]',
        itemLabelIconWrapper: 'flex items-center',
        itemLabelWrapper: 'text-primary-13',
        itemSelectedIconWrapper: 'flex h-[20px] w-[20px]',
        itemSelectedIcon: 'text-primary-13',
        errorTooltipTrigger: 'text-error-8'
    },
    variants: {
        isInset: {
            true: {
                label: 'absolute left-[17px] z-1 mb-0 text-primary-10',
                input: 'translate-y-2'
            }
        },
        size: {
            sm: {
                inputWrapper: 'h-[32px] rounded-xl'
            },
            md: {
                inputWrapper: 'h-[48px]'
            },
            lg: {
                inputWrapper: 'h-[56px]'
            }
        },
        hasIconLeft: {
            true: {
                input: 'ml-0'
            }
        },
        hasValue: {
            true: {
                input: 'text-primary-13'
            },
            false: {
                input: 'text-primary-10'
            }
        },
        hasPlaceholder: {
            true: {}
        },
        isError: {
            true: {
                inputWrapper: 'border-error-7 transition focus-within:border-error-8 hover:border-error-8 hover:shadow-input-error focus-visible:outline-error-8'
            }
        },
        isDisabled: {
            true: {
                iconLeft: 'text-primary-6',
                iconRight: 'text-primary-6',
                inputWrapper: 'cursor-not-allowed border-primary-5 bg-primary-2 hover:cursor-not-allowed hover:border-none hover:shadow-none',
                input: 'text-primary-6'
            }
        },
        itemSelected: {
            true: {
                popupItem: 'bg-primary-4 [&:hover,&:focus]:bg-primary-7'
            }
        },
        itemDisabled: {
            true: {
                itemLabelWrapper: 'text-primary-6',
                itemSuffix: 'text-primary-6',
                itemIcon: 'text-primary-6',
                popupItem: 'cursor-not-allowed hover:cursor-not-allowed'
            }
        },
        itemSuffixInline: {
            true: {
                itemLabelIconSuffixWrapper: 'justify-start gap-0'
            }
        },
        isLabelHidden: {
            true: {
                label: 'hidden'
            }
        },
        menuOpen: {
            true: {
                inputWrapper: 'border-primary-8 shadow-input-focus'
            }
        }
    },
    compoundVariants: [
        {
            isInset: true,
            isDisabled: true,
            class: {
                label: 'text-primary-6'
            }
        },
        {
            isInset: true,
            size: 'sm',
            class: {
                label: 'translate-y-0'
            }
        },
        {
            isInset: true,
            size: 'md',
            class: {
                label: 'translate-y-1.5'
            }
        },
        {
            isInset: true,
            size: 'lg',
            class: {
                label: 'translate-y-2'
            }
        },
        {
            hasIconLeft: true,
            isInset: true,
            class: {
                label: 'left-13 ml-[1px]'
            }
        },
        {
            hasValue: false,
            hasPlaceholder: false,
            isInset: true,
            class: {
                input: 'translate-none',
                label: 'invisible'
            }
        },
        {
            menuOpen: true,
            isError: true,
            class: {
                inputWrapper: 'border-error-8 shadow-input-error transition hover:shadow-input-error'
            }
        }
    ],
    defaultVariants: {
        emphasis: 'regular',
        isInset: false,
        size: 'md'
    }
});
const selectVariants = Select_variants_select;
export { Select_variants_select as select, selectVariants };
